import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class AppService {

  http = inject(HttpClient)

  async sendIt(formData: any): Promise<string> {
    console.log('sendIt', formData);
    const result = await firstValueFrom(this.http.post<{submitionId?: string}>('/api/claims', formData));
    if (!result.submitionId){
      throw new Error('No submitionId');
    }
    return result.submitionId;
  }
}
